export default "__VITE_ASSET__CELjN_2o__"